import React from "react";
import { observer, inject } from "mobx-react";
import { STORE_AUTH } from "../../../../../../constants";
import { Form } from "react-bootstrap";
import { wrapCheckbox } from "../../../../../../common/FormChangeWrapper";
import { AuthStore } from "../../../../../../stores";

interface IProps {
    deliveryType: "delivery" | "pickup";
    paymentType: "Cache" | "Cacheless" | "ByReceipt";
    isUrgent: boolean;
    sendPaymentLink: boolean;
    setAddressTypeCallback: (deliveryType: "delivery" | "pickup", isUrgent: boolean) => void;
    setPaymentTypeCallback: (paymentType: "Cache" | "Cacheless" | "ByReceipt") => void;
    changeCheckboxesCallback: (fieldName: string, value: string, checked: boolean) => void;
}

@inject(STORE_AUTH)
@observer
export class ConfirmationStep2Ab extends React.Component<IProps, {}> {
    constructor(props: any) {
        super(props);
    }

    authStore = (this.props as any)[STORE_AUTH] as AuthStore;


    private changeDeliveryTypeHandler = (fieldName: string, value: string, checked: boolean) => {
        if (fieldName == "deliveryType") {
            this.props.setAddressTypeCallback(value as "delivery" | "pickup", this.props.isUrgent && value == "pickup");
        }
        else
            this.props.setAddressTypeCallback(this.props.deliveryType, checked);
    }
    private changePaymentTypeHandler = (fieldName: string, value: string, checked: boolean) => {
        if (fieldName == "paymentType") {
            this.props.setPaymentTypeCallback(value as "Cache" | "Cacheless" | "ByReceipt");
        }
    }

    render() {
        return <Form>
            <Form.Check
                type="radio"
                id="delivery_plan"
                name="deliveryType"
                checked={this.props.deliveryType == "delivery"}
                value="delivery"
                label="Плановая доставка"
                onChange={wrapCheckbox(this.changeDeliveryTypeHandler)}
            />
            <Form.Check
                type="radio"
                id="delivery_pickup"
                checked={this.props.deliveryType == "pickup"}
                value="pickup"
                name="deliveryType"
                label="Самовывоз"
                onChange={wrapCheckbox(this.changeDeliveryTypeHandler)}
            />
            {this.props.deliveryType == "pickup" && this.authStore.isCallCentre ?
                <Form.Check
                    type="checkbox"
                    id="delivery_urgent"
                    checked={this.props.isUrgent}
                    name="isUrgent"
                    label="Срочная сборка"
                    onChange={wrapCheckbox(this.changeDeliveryTypeHandler)}
                /> : []}

            <hr />
            <Form.Check
                type="radio"
                id="paymentType"
                name="paymentType"
                checked={this.props.paymentType == "Cache"}
                value="Cache"
                label="Наличная оплата"
                onChange={wrapCheckbox(this.changePaymentTypeHandler)}
            />
            <Form.Check
                type="radio"
                id="paymentType"
                checked={this.props.paymentType == "Cacheless"}
                value="Cacheless"
                name="paymentType"
                label="Оплата картой"
                onChange={wrapCheckbox(this.changePaymentTypeHandler)}
            />
            <Form.Check
                type="radio"
                id="paymentType"
                checked={this.props.paymentType == "ByReceipt"}
                value="ByReceipt"
                name="paymentType"
                label="Оплата по счету"
                onChange={wrapCheckbox(this.changePaymentTypeHandler)}
            />

            {this.props.paymentType == "Cacheless" ?
                <Form.Check
                    type="checkbox"
                    id="send_payment_link"
                    checked={this.props.sendPaymentLink}
                    name="sendPayLink"
                    label="Отправить ссылку на оплату в смс"
                    onChange={wrapCheckbox(this.props.changeCheckboxesCallback)}
                /> : []}

        </Form>
    }
}